import React from "react";
import { hideCardRef } from "../../../helpers";
import flag from "../../../../images/flag.svg";
import { useSourceSystem } from "../../../../hooks/useSourceSystem";

export const WhatHappensNextModal = ({ happensNextCardRef }) => {
  const { sourceSystem } = useSourceSystem();
  const {
    initialOfferContent: { whatHappensNextContent }
  } = sourceSystem;
  return (
    <div className="modal__whatHappens" ref={happensNextCardRef}>
      <div className="modal-content__whatHappens ch-pa--3 ch-card">
        <div className="ch-container">
          <div className="ch-display--flex ch-justify-content--between">
            <div />
            <span
              className="icon__close"
              onClick={() => hideCardRef(happensNextCardRef)}
            ></span>
          </div>
          <div className="ch-display--flex ch-flex-flow--column-nowrap">
            <div className="ch-display--flex ch-justify-content--center">
              <img src={flag} alt="blue flag" className="icon--flag" />
            </div>
            <div className="ch-display--flex ch-justify-content--center ch-mb--2">
              <h3>What happens next?</h3>
            </div>
            <div className="ch-row">
              <div
                className="md:ch-col--10 md:ch-col--offset-1"
                data-testid="what-happens-next-content"
              >
                {whatHappensNextContent}
              </div>
              <div className="ch-display--flex ch-justify-content--center ch-width--12 ">
                <button
                  className="ch-btn ch-btn--success ch-width--12 sl:ch-width--8 sl:ch-mt--10 modal-content__whatHappens--button"
                  onClick={() => hideCardRef(happensNextCardRef)}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
